"use client";

import React from 'react';
import { useRouter } from 'next/navigation';
import categoriesData from '../../utils/categories.json';
import { useLocalizedPath } from '../../hooks/useLocalizedPath';
import styles from './DesktopCategoriesDropdown.module.css';

interface DesktopCategoriesDropdownProps {
  isOpen: boolean;
  categoryNames: Record<string, string>;
}

export const DesktopCategoriesDropdown: React.FC<DesktopCategoriesDropdownProps> = ({ isOpen, categoryNames }) => {
  const router = useRouter();
  const { localizeFullPath } = useLocalizedPath();

  const handleCategoryClick = (slug: string) => {
    router.push(localizeFullPath(`/giftcards/${slug}`));
  };

  return (
    <div className={`${styles.dropdownContainer}${isOpen ? ` ${styles.open}` : ''}`}>
      <div className={styles.categoriesGrid}>
        {categoriesData.map((category) => (
          <div
            key={category.Slug}
            className={styles.categoryItem}
            onClick={() => handleCategoryClick(category.Slug)}
          >
            <span className={styles.categoryIcon}>{category.Icon}</span>
            <span className={styles.categoryName}>{categoryNames[category.Slug] || category.Name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
